// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItem-cls1_tAz","cls2":"CreateSocialItem-cls2_rYl CreateSocialItem-cls1_tAz"};